import { fragments as embroideryOrderStatusFragments } from "../../application/apps/EmbroideryApp/components/EmbroideryOrderStatus/graph";
import { gql } from "@apollo/client";

const markOrderAsEmbroideryCompletedMutation = gql`
  mutation($orderId: ID!) {
    markOrderAsEmbroideryCompleted(orderId: $orderId) {
      errors {
        orderId
      }
      order {
        ...EmbroideryOrderStatus_order
      }
      succeeded
    }
  }
  ${embroideryOrderStatusFragments.order}
`;

export default markOrderAsEmbroideryCompletedMutation;
